// extracted by mini-css-extract-plugin
export default {"HiddenNavBar":"HiddenNavBar_HiddenNavBar__R-cHt","LogoWrapper":"HiddenNavBar_LogoWrapper__TjBNt","LanguageSwitch":"HiddenNavBar_LanguageSwitch__qfYaF"};